import { Option } from "@opendaw/lib-std";
// The injection point for THE engine. studio-core cannot import studio-core-wasm (that package depends on this
// one), so the wasm engine installs itself here and `EngineWorklet` resolves it at construction.
export class EngineVariant {
    static install(provider) {
        this.#provider = Option.wrap(provider);
    }
    // The variant to boot the NEXT EngineWorklet with, resolved at construction time so an engine restart
    // picks up a re-install. There is no built-in engine to fall back to, so a missing provider is a boot
    // error (`WasmEngine.install` never ran, or its artifacts failed to load) rather than a silent downgrade.
    static current() {
        return this.#provider.unwrap("No engine installed (WasmEngine.install must run before an engine boots)")();
    }
    static #provider = Option.None;
}
